


































































































import Vue from 'vue';
import moment from 'moment';
import { dateFormat, dateTransactionFormat } from '@/constants';
import { TransactionDetail } from '@/components/account-components/account-activity-components/account-activity-child-components';
import { TableHeader } from '@/@types/member';

interface Data {
  selectedClaimId: string;
  dateFormat: string;
  dateTransactionFormat: string;
  pagination: {
    descending: boolean;
    sortBy: string,
  };
  claimData: any[];
}

export default Vue.extend({
  name: 'ClaimTable',
  data(): Data {
    return {
      selectedClaimId: '',
      dateFormat,
      dateTransactionFormat,
      pagination: {
        descending: true,
        sortBy: 'postedDate',
      },
      claimData: [],
    };
  },
  beforeMount() {
    this.claimData = this.claimsSortedByPostedDate;
  },
  computed: {
    headers(): TableHeader[] {
      const array: TableHeader[] = [
        {},
        {
          text: this.$options.filters.t(
            'match-to-transaction_label_posted-date',
          ),
          align: 'left',
          value: 'postedDate',
        },
        {
          text: this.$options.filters.t(
            'match-to-transaction_label_description',
          ),
          align: 'left',
          value: 'description',
        },
        {
          text: this.$options.filters.t(
            'match-to-transaction_label_transaction-type',
          ),
          align: 'left',
          value: 'transactionType',
        },
        {
          text: this.$options.filters.t(
            'match-to-transaction_label_payment-amount',
          ),
          align: 'right',
          value: 'paymentAmount',
        },
        {},
      ];
      if (this.$vuetify.breakpoint.mdAndDown) {
        array.pop();
      }
      return array;
    },
    claimsSortedByPostedDate(): any {
      const returnFlag = this.pagination.descending ? 1 : -1;
      return this.$store.getters.claimData.sort((a, b) => {
        const aPostedDate = moment(a.postedDate, dateFormat),
          aPaymentAmount = parseFloat(a.paymentAmount),
          bPostedDate = moment(b.postedDate, dateFormat),
          bPaymentAmount = parseFloat(b.paymentAmount);
        if (aPostedDate.isAfter(bPostedDate)) { return -returnFlag; }
        if (aPostedDate.isBefore(bPostedDate)) { return returnFlag; }
        if (aPostedDate.isSame(bPostedDate)) {
          if (aPaymentAmount < bPaymentAmount) { return 1; }
          if (aPaymentAmount > bPaymentAmount) { return -1; }
          if (aPaymentAmount === bPaymentAmount) { return 0; }
        }
      });
    },
    claimsSortedByDescription(): any {
      const returnFlag = this.pagination.descending ? 1 : -1;
      return this.$store.getters.claimData.sort((a, b) => {
        const aDescription = a.description.toUpperCase(),
          aPostedDate = moment(a.postedDate, dateFormat),
          bDescription = b.description.toUpperCase(),
          bPostedDate = moment(b.postedDate, dateFormat);
        if (aDescription > bDescription) { return -returnFlag; }
        if (aDescription < bDescription) { return returnFlag; }
        if (aDescription === bDescription) {
          if (aPostedDate.isAfter(bPostedDate)) { return 1; }
          if (aPostedDate.isBefore(bPostedDate)) { return -1; }
          if (aPostedDate.isSame(bPostedDate)) { return 0; }
        }
      });
    },
    claimsSortedByTransactionType(): any {
      const returnFlag = this.pagination.descending ? 1 : -1;
      return this.$store.getters.claimData.sort((a, b) => {
        const aTransactionType = a.transactionType.toUpperCase(),
          aPostedDate = moment(a.postedDate, dateFormat),
          bTransactionType = b.transactionType.toUpperCase(),
          bPostedDate = moment(b.postedDate, dateFormat);
        if (aTransactionType > bTransactionType) { return -returnFlag; }
        if (aTransactionType < bTransactionType) { return returnFlag; }
        if (aTransactionType === bTransactionType) {
          if (aPostedDate.isAfter(bPostedDate)) { return 1; }
          if (aPostedDate.isBefore(bPostedDate)) { return -1; }
          if (aPostedDate.isSame(bPostedDate)) { return 0; }
        }
      });
    },
    claimsSortedByPaymentAmount(): any {
      const returnFlag = this.pagination.descending ? 1 : -1;
      return this.$store.getters.claimData.sort((a, b) => {
        const aPostedDate = moment(a.postedDate, dateFormat),
          aPaymentAmount = parseFloat(a.paymentAmount),
          bPostedDate = moment(b.postedDate, dateFormat),
          bPaymentAmount = parseFloat(b.paymentAmount);
        if (aPaymentAmount > bPaymentAmount) { return -returnFlag; }
        if (aPaymentAmount < bPaymentAmount) { return returnFlag; }
        if (aPaymentAmount === bPaymentAmount) {
          if (aPostedDate.isAfter(bPostedDate)) { return 1; }
          if (aPostedDate.isBefore(bPostedDate)) { return -1; }
          if (aPostedDate.isSame(bPostedDate)) { return 0; }
        }
      });
    },
    selectedClaim(): any[] {
      return this.claimData.find((claim) => {
        return claim.id === this.selectedClaimId;
      });
    },
  },
  methods: {
    setSelectedClaim(claimId): void {
      this.selectedClaimId = claimId;
      this.$emit('setSelectedClaim', this.selectedClaim);
    },
    changeSort(column): void {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
      this.updateSort();
    },
    updateSort(): void {
      switch (this.pagination.sortBy) {
        case 'postedDate':
          // @ts-ignore
          this.claims = this.claimsSortedByPostedDate;
          break;
        case 'description':
          // @ts-ignore
          this.claims = this.claimsSortedByDescription;
          break;
        case 'transactionType':
          // @ts-ignore
          this.claims = this.claimsSortedByTransactionType;
          break;
        case 'paymentAmount':
          // @ts-ignore
          this.claims = this.claimsSortedByPaymentAmount;
          break;
        default:
          // @ts-ignore
          this.claims = this.claimsSortedByPostedDate;
      }
    },
  },
  components: {
    TransactionDetail,
  },
});
